import {Component, HostListener, Input} from '@angular/core';
import {ComponentAsElement} from '../../services/common/bootstrap/annotation/component-as-element';

@ComponentAsElement('v-spinner-element')
@Component({
  selector: 'v-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: []
})
export class SpinnerComponent {
  public static readonly SHOW_SPINNER = 'showspinner';
  public static readonly HIDE_SPINNER = 'hidespinner';
  public showSpinner = false;
  @Input() activeSpinner = false;

  @HostListener(SpinnerComponent.SHOW_SPINNER)
  handleStartSpinner() {
    this.showSpinner = true;
  }

  @HostListener(SpinnerComponent.HIDE_SPINNER)
  handleStopSpinner() {
    this.showSpinner = false;
  }

  @HostListener('click', ['$event'])
  handleClick($event: UIEvent) {
    if (this.showSpinner) {
      $event.preventDefault();
      $event.stopPropagation();
    }
  }
}
